var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (current, labels, undefined) {
// iterate labels
;(function(){
  var $$obj = labels;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var label = $$obj[i];

buf.push("<li" + (jade.attr("aria-selected", (i==current-1)?'true':'false', true, true)) + ">" + (jade.escape(null == (jade_interp = label) ? "" : jade_interp)) + "</li>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var label = $$obj[i];

buf.push("<li" + (jade.attr("aria-selected", (i==current-1)?'true':'false', true, true)) + ">" + (jade.escape(null == (jade_interp = label) ? "" : jade_interp)) + "</li>");
    }

  }
}).call(this);
}.call(this,"current" in locals_for_with?locals_for_with.current:typeof current!=="undefined"?current:undefined,"labels" in locals_for_with?locals_for_with.labels:typeof labels!=="undefined"?labels:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/views/templates/progression.jade
// module id = 18
// module chunks = 0